import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {

}
export class SelectWithRichTextComponent extends React.Component<Props, State> {
 
  
  constructor(props: Props) {
    super(props);

    let field = this.props.field;
    field.IsDirty = false;
    FormValidationUtils.runJavascript(field);
  }

  onDropdownChange = (e) => {
   
    let field = this.props.field;
    let val = null;

    if (e.value) {
      val = e.value;
    } else {
      let elem = e.originalEvent ? e.originalEvent.target : e.target;
      val = elem.value;
    }
    field.SelectionCode=val;
    FormValidationUtils.markFieldDirty(field);
    const item = field.ListOfLOVValues.filter(p => p.code == val);
   
    FormValidationUtils.validateSelectWithRichText(field);
    
    if (item.length>0) {
      if (this.props.isEng) {
      field.Value=item[0].richText; 
      } else {
         field.Value=item[0].richTextFRA;
      }
    } else {
      field.Value="";
    }
    FormValidationUtils.runJavascript(field);

    this.props.callbackElement(getRootComponent(field));
  }

  generateHtml = () => {
    let field = this.props.field;
    if(!field.Visible) return null;

    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    let controlArrayHtml = [];
 
    const lovOptions = field.ListOfLOVValues;
   
    let editable = this.props.editable;

    let title = this.props.title;
    if (editable) {
      var lovCheckList = [];
      field.ListOfLOVValues.forEach(lov => {
        let selectOptionName = (this.props.isEng ? lov.description :lov.FRADescription );
        if (selectOptionName === null || selectOptionName === '') {
          selectOptionName = (this.props.isEng  ? lov.code:lov.FRA);
        }
        let selectOptionValue = this.props.isEng ? lov.code:lov.FRA;

        let baseName;
        let bindName;
        let filterValue;
        let foundFilterFields: FormSectionElements[];
        let foundFilterField: FormSectionElements;
        if (lov.FilterField != null) {
          let parts = lov.FilterField.split('.');
          if (parts.length == 3) {
            baseName = parts[0] + '.' + parts[1];
            bindName = parts[2];
          }
          if (parts.length == 2) {
            baseName = parts[0];
            bindName = parts[1];
          }
          if (parts.length == 1) {
            baseName = '';
            bindName = parts[0];
          }

          let subSection: FormSubSections = field.parent as FormSubSections;
          foundFilterFields = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == bindName);
          if (foundFilterFields != null && foundFilterFields.length > 0) {
            foundFilterField = foundFilterFields[0];
          }

          if (foundFilterField) {
            filterValue = foundFilterField.Value;
          }
        }

        //if filter value is null we dont display the control
        if (filterValue != null && lov.FilterValue == filterValue || (foundFilterField == null && filterValue == null)) {
          lovCheckList.push({
            'Sequence': lov.Sequence,
            'value': selectOptionValue,
            'description': selectOptionName
          }
          );
        }
      });

      //if there is a need to filter more from element level
      if (field.FilterField != null) {
        let parts = field.FilterField.split('.');
        let baseName;
        let bindName;
        if (parts.length == 3) {
          baseName = parts[0] + '.' + parts[1];
          bindName = parts[2];
        }
        if (parts.length == 2) {
          baseName = parts[0];
          bindName = parts[1];
        }
        if (parts.length == 1) {
          baseName = '';
          bindName = parts[0];
        }

        // let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName, this.entityType);
        let subSection: FormSubSections = field.parent as FormSubSections;
        let foundFilterFields = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == bindName);
        let foundFilterField;
        if (foundFilterFields.length == 1)
          foundFilterField = foundFilterFields.at(0);

        if (field.FilterValue == 'exclude' && lovCheckList != null && foundFilterField != null && foundFilterField.Value != null) {
          lovCheckList = lovCheckList.filter(p => foundFilterField.Value.indexOf(p.value) == -1);
        }
      }

      if (lovCheckList.length > 0) {
        controlArrayHtml.push(this.props.labelControlArray);
        controlArrayHtml.push(
          <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />


            <select
              className={'ontario-input ontario-dropdown'}
              id={'fdIpt_' + field.Id}
              key={'fdIpt_' + field.Id}
              value={this.props.field.SelectionCode}
              onChange={this.onDropdownChange}>
              <option value="" selected></option>
              {lovOptions.map((option, index) => (
                <option key={option.code} value={option.code}>
                  {this.props.isEng ? option.description : option.FRADescription}
                </option>
              ))}
            </select>
            <label>{htmlToReactParser.parse(field.Value)}</label>
          </div>
        );
      }
    } else {
      controlArrayHtml.push(
        <div className='pdf-two-column'>
          <div>{title}</div>
          <div>{htmlToReactParser.parse(field.Value)}</div>
        </div>
      );
    }

    return controlArrayHtml;
  }


  render() {
    return  this.generateHtml();
  }
}
